import moment from 'moment';

import { DeclarationCustomsFlowType, DeclarationStatus } from '../enums';

export interface PresentationDeadlineInfo {
  flow: DeclarationCustomsFlowType | undefined;
  declarationStatus: DeclarationStatus | undefined;
  prelodgeStatus: DeclarationStatus | undefined;
  presentationDueDate: Date | string | undefined;
}

export const isAwaitingPresentation = (info: PresentationDeadlineInfo): boolean =>
  info.flow === DeclarationCustomsFlowType.PRE && info.declarationStatus === DeclarationStatus.ACCEPTED && info.prelodgeStatus === DeclarationStatus.ACCEPTED;

export const isPresentationDeadlinePassed = (dueDate?: Date | string): boolean => {
  if (!dueDate) {
    return false;
  }

  return moment().isAfter(moment(dueDate).endOf('day'));
};

export const isPresentationOverdue = (info: PresentationDeadlineInfo): boolean =>
  isAwaitingPresentation(info) && isPresentationDeadlinePassed(info.presentationDueDate);
